import React, { useState } from 'react';
import { Bold, Italic } from 'lucide-react';

interface Props {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  className?: string;
  minHeight?: string;
}

export function TextEditor({ value, onChange, placeholder, className = '', minHeight = '150px' }: Props) {
  const [selectionStart, setSelectionStart] = useState(0);
  const [selectionEnd, setSelectionEnd] = useState(0);

  const handleSelect = (e: React.SyntheticEvent<HTMLTextAreaElement>) => {
    const textarea = e.target as HTMLTextAreaElement;
    setSelectionStart(textarea.selectionStart);
    setSelectionEnd(textarea.selectionEnd);
  };

  const applyFormat = (format: 'bold' | 'italic') => {
    const marker = format === 'bold' ? '**' : '_';
    const newValue = 
      value.substring(0, selectionStart) +
      marker +
      value.substring(selectionStart, selectionEnd) +
      marker +
      value.substring(selectionEnd);
    
    onChange(newValue);
  };

  return (
    <div className="space-y-2">
      <div className="flex gap-2">
        <button
          onClick={() => applyFormat('bold')}
          className="p-1.5 rounded hover:bg-gray-100 text-gray-700 transition-colors"
          title="Mettre en gras (entourez le texte avec **)"
        >
          <Bold className="w-4 h-4" />
        </button>
        <button
          onClick={() => applyFormat('italic')}
          className="p-1.5 rounded hover:bg-gray-100 text-gray-700 transition-colors"
          title="Mettre en italique (entourez le texte avec _)"
        >
          <Italic className="w-4 h-4" />
        </button>
      </div>
      <textarea
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onSelect={handleSelect}
        className={`w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-purple-500 transition-colors resize-y ${className}`}
        placeholder={placeholder}
        style={{ minHeight }}
      />
      <div className="text-xs text-gray-500">
        Utilisez ** pour le gras et _ pour l'italique
      </div>
    </div>
  );
}